var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.168,
    height: 13.199,
    viewBox: "0 0 19.168 13.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-new",
    transform: "translate(-3 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31988",
    "data-name": "Path 31988",
    d: "M12.443,20.879H4.111l0-9.961,6.351,5.224a.485.485,0,0,0,.632,0l6.349-5.222V13.84h1.111V10.32A1.231,1.231,0,0,0,17.442,9H4.111A1.23,1.23,0,0,0,3,10.32V20.879A1.231,1.231,0,0,0,4.111,22.2h8.332ZM16.219,10.32,10.776,14.8,5.333,10.32Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(12.937 14.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31989",
    "data-name": "Path 31989",
    d: "M10,9.5l3.769-3.769L15.5,7.461,11.731,11.23H10Zm4.346-4.346L15.5,4,17.23,5.731,16.076,6.885Z",
    transform: "translate(-8 -4)",
    fill: "#777",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNew);
export default __webpack_public_path__ + "static/media/email-new.2c41579def65389347ab74bb5a269f04.svg";
export { ForwardRef as ReactComponent };